import type { ServiceRequestMessage } from "bonusx-api-main-manager";

export function getSortedChatMessagesFromNewestToOldest(messages: ServiceRequestMessage[]): ServiceRequestMessage[] {
  const sortedMessages = [...messages];
  const fallbackDate = new Date();

  sortedMessages.sort((messageA, messageB) => {
    const dateA = new Date(messageA.created_at ?? fallbackDate).getTime();
    const dateB = new Date(messageB.created_at ?? fallbackDate).getTime();
    return dateB - dateA;
  });

  return sortedMessages;
}
